export const SET_DISTRIBUTORS = 'SET_DISTRIBUTORS'
export const SET_DISTRIBUTORS_PAYMENT_HISTORY =
  'SET_DISTRIBUTORS_PAYMENT_HISTORY'
export const SET_FILTERS = 'SET_FILTERS'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const SET_BY_ORDER_FILTER_OPTIONS = 'SET_BY_ORDER_FILTER_OPTIONS'
export const CLEAR_BY_ORDER_FILTER_OPTIONS = 'CLEAR_BY_ORDER_FILTER_OPTIONS'
export const SET_PURCHASE_ORDER_ID_FILTER = 'SET_PURCHASE_ORDER_ID_FILTER'
export const SET_ARCHIVED_FILTER = 'SET_ARCHIVED_FILTER'
